import { Box } from '@mui/material';
import * as React from 'react';
import { archLevel } from 'src/data/config';
import { useLazyGetsqReportDataQuery } from 'src/services/SqReport';
import { setPath } from 'src/store/Navigation';
import { clearSubjectInfo, setSelectedSubject } from 'src/store/SelectedSubject';
import { setTabsData } from 'src/store/Tabs';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { Translation } from 'src/types/Translation';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import AlertDialog from '../common/AlertDialog';
import { TabsControl } from '../common/TabsControl';
import { useTab } from '../hooks/useTab';
import { useTranslations } from '../hooks/useTranslations';
import { useUser } from '../hooks/useUser';
import './MainTabs.scss';
import { MENU_GROUPS } from './MainTabsData';
import { useGetAllcodelistDataQuery } from 'src/services/codeList';
import { setCodelistData } from 'src/store/codelistData';
import SQPopup from '../StartUp/sqReport/SQPopup';
import { useSelector } from 'react-redux';
import { setSqReportPopupValue } from 'src/store/sqReport';
import { useGetStudyInfoQuery } from 'src/services/issueLog';
import {
  clearIntrialPatientInfo,
  clearSelectedIntrialPatient,
  setActiveStep,
  setPlannedDate
} from 'src/store/SelectedIntrialPatient';
import { hideLoader, showLoader } from 'src/store/Loader';

const MainTabs: React.FC = () => {
  const dispatch = useAppDispatch();
  const { selectedApp } = useSelectedAppInfo();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const country = useAppSelector(state => state.site.selectedCountry);
  const siteId = useAppSelector(state => state.site.selectedSite);
  const selectedRowData: any = useAppSelector(state => state.sqReport.selectedRowData);
  const application = process.env.REACT_APP_NAME;
  const selectedStudy: string | null = useAppSelector(state => state.site.selectedStudy);

  const [
    getsqReportQueryData1,
    { isLoading: getsqReportLoading1, data: sqReportQueryData1, error: getsqReportError1 }
  ] = useLazyGetsqReportDataQuery();

  const { tabVal, setTabVal, tabsData } = useTab();
  const { roles } = useUser();
  const tabsLabels = useTranslations({} as Translation, { returnObjects: true }, 'tabs');

  const sqReportTabChange: any = useSelector((state: any) => state.sqReport.sqReportTabChange);
  const sqReportPopupValue: any = useSelector((state: any) => state.sqReport.sqReportPopupValue);

  const handleChange = (_event: React.SyntheticEvent, newValue: any) => {
    const temp = filtered.find((item: any) => item.index == tabVal);
    if (temp?.key == 'sqReport' && sqReportTabChange) {
      dispatch(setSqReportPopupValue(true));
    }
    setTabVal(newValue);
    setConfirmExitPopupVal(dispatch, true);
    if (newValue != 2) {
      dispatch(setSelectedSubject(''));
    }
    dispatch(setPath('')); //Setting redirection path value to empty string
    /* to clear patient trial notebook tab */
    dispatch(clearSelectedIntrialPatient());
    dispatch(clearIntrialPatientInfo());
    dispatch(clearSubjectInfo());
    dispatch(setPlannedDate(null));
    dispatch(setActiveStep(0));
    /*end*/
  };

  const { data: getStudyDetailsData, isLoading: getStudyDetailsLoading } = useGetStudyInfoQuery({
    study_id: selectedStudy,
    application: archLevel === 'site' ? process.env.REACT_APP_TSDA_SLUG : process.env.REACT_APP_NAME
  });

  const filtered = React.useMemo(() => {
    if (roles !== undefined && roles !== null && selectedApp !== '') {
      let tempTabsData: any;
      if (archLevel == 'site') {
        tempTabsData = MENU_GROUPS[selectedApp].filter(
          (item: any) => item.archLevel == 'site' || item.archLevel == 'siteOnly'
        );
      } else {
        tempTabsData = MENU_GROUPS[selectedApp].filter((item: any) => !item.archLevel || item.archLevel != 'siteOnly');
      }

      let filtered = tempTabsData.filter((item: any) => {
        if (
          (item.permissions_pil == 'VIEW_SQ_REPORT_AFTER_SUBMIT' &&
            roles.includes('VIEW_SQ_REPORT_AFTER_SUBMIT') &&
            !roles.includes('VIEW_SQ_REPORT') &&
            sqReportQueryData1 &&
            sqReportQueryData1?.report_data?.is_submit &&
            !getsqReportError1) ||
          roles.includes('VIEW_SQ_REPORT')
        ) {
          return item;
        } else if (roles.includes(item.permissions) || roles.includes(item.permissions_pil)) {
          if (item.permissions_pil !== 'VIEW_SQ_REPORT_AFTER_SUBMIT') {
            return item;
          } else if (getsqReportError1 && !roles.includes('VIEW_SQ_REPORT_AFTER_SUBMIT')) {
            return item;
          } else if (roles.includes(item.permissions) || roles.includes(item.permissions_pil)) {
            if (item.permissions_pil !== 'VIEW_SQ_REPORT_AFTER_SUBMIT') {
              return item;
            } else if (getsqReportError1 && !roles.includes('VIEW_SQ_REPORT_AFTER_SUBMIT')) {
              return item;
            }
          }
        }
      });
      filtered = filtered.filter(
        (item: any) => roles.includes(item.permissions) || roles.includes(item.permissions_pil)
      );
      if (getStudyDetailsData?.non_interventional) {
        const found: any = tabsData?.find((tab: any) => tab.index === tabVal);
        if (found?.key === `ipManagement`) {
          setTabVal(0);
        }
        filtered = filtered.filter((ele: any) => ele.key != 'ipManagement');
      }
      if (getStudyDetailsData?.non_interventional) {
        filtered = filtered.filter((ele: any) => ele.key != 'drugSupply');
      }
      const filteredData = filtered.map((item: any, indexVal: number) => {
        if (!(typeof filtered[indexVal + 1] === 'undefined')) {
          return { ...item, index: indexVal, NextButton: true };
        } else {
          return { ...item, index: indexVal };
        }
      });
      if (!getStudyDetailsLoading) {
        dispatch(setTabsData(filteredData));
      }
      if (
        !getStudyDetailsLoading &&
        ((siteId !== null && selectedApp === process.env.REACT_APP_STARTUP_NAME) ||
          selectedApp === process.env.REACT_APP_CONDUCT_NAME ||
          selectedApp === process.env.REACT_APP_CLOSEOUT_NAME)
      ) {
        return filteredData;
      }
    }
    return [];
  }, [
    roles,
    selectedApp,
    getsqReportLoading1,
    sqReportQueryData1,
    getsqReportError1,
    siteId,
    getStudyDetailsData,
    selectedStudy,
    getStudyDetailsLoading
  ]);
  const {
    data: getAllCodelistData,
    isLoading: getAllCodelistIsLoading,
    isError: getAllCodelistIsError,
    isSuccess: getAllCodelistIsSuccess
  } = useGetAllcodelistDataQuery();

  React.useEffect(() => {
    if (getAllCodelistData && getAllCodelistIsSuccess && !getAllCodelistIsError && !getAllCodelistIsLoading) {
      dispatch(setCodelistData(getAllCodelistData));
    }
  }, [getAllCodelistData, getAllCodelistIsLoading, getAllCodelistIsError, getAllCodelistIsSuccess]);

  React.useEffect(() => {
    if (selectedApp === process.env.REACT_APP_STARTUP_NAME) {
      if (siteId != '' && selectedRowData?.id) {
        getsqReportQueryData1({
          monitoring_visit_id: selectedRowData.id,
          site_id: siteId,
          study_id: studyId,
          country,
          application
        });
      }
    }
  }, [siteId]);

  React.useEffect(() => {
    if (getStudyDetailsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [getStudyDetailsLoading]);

  return (
    <Box
      className="site-contact-page"
      sx={{
        padding: '0 0 0 225px'
      }}
    >
      {sqReportPopupValue ? <SQPopup /> : <AlertDialog />}
      <TabsControl
        tabsLabels={tabsLabels.tabs}
        tabs={filtered && filtered.length > 0 ? filtered : []}
        gridParent={{ container: true }}
        gridTabs={{ item: true, xs: 2 }}
        tabsProps={{
          className: 'lefttabs',
          orientation: 'vertical',
          'aria-label': 'CTMS Vertical tabs',
          sx: { '.MuiTabs-indicator': { left: 0, right: 'auto' } },
          onChange: handleChange
        }}
        tabProps={{ sx: { alignItems: 'start', textAlign: 'left' } }}
        gridTabsControlContainer={{ item: true, xs: 10 }}
        value={tabVal}
        tabContainer={{ role: 'tabpanel' }}
      />
    </Box>
  );
};

export default MainTabs;
